/**
 * Shared constants for feature flags UI
 */

export type Category = "all" | "billing" | "admin_ui" | "visitor_ui" | "api";

export const CATEGORIES: { value: Category; label: string }[] = [
  { value: "all", label: "All" },
  { value: "billing", label: "Billing" },
  { value: "admin_ui", label: "Admin UI" },
  { value: "visitor_ui", label: "Visitor UI" },
  { value: "api", label: "API" },
];

export const FLAG_TYPES = [
  { value: "boolean", label: "Boolean" },
  { value: "percentage", label: "Percentage" },
  { value: "variant", label: "Variant" },
] as const;

export const TIERS = [
  { value: "none", label: "None" },
  { value: "base", label: "Base" },
  { value: "pro", label: "Pro" },
  { value: "premium", label: "Premium" },
  { value: "enterprise", label: "Enterprise" },
] as const;

export const FORM_CATEGORIES = [
  { value: "billing", label: "Billing" },
  { value: "admin_ui", label: "Admin UI" },
  { value: "visitor_ui", label: "Visitor UI" },
  { value: "api", label: "API" },
] as const;
